import { Character } from './Character';
import { PathNode } from '../world/PathNode';
import { IDamageable } from '../interfaces/IDamageable';
import { IDieable } from '../interfaces/IDieable';
import { Die } from './states/Die';
import * as THREE from 'three';
import { PedestrianBehavior } from './ai/PedestrianBehavior';
import { CopBehaviour } from './ai/CopBehaviour';
import { HeadLookAt } from './ai/HeadLookAt';
import { World } from '../world/World';
import { NavMesh } from '../world/NavMesh';

export class Npc extends Character implements IDamageable, IDieable {
    name: string;
    private readonly headLookAt: HeadLookAt;

    constructor(gltf: any, animations?: THREE.AnimationClip[]) {
        super(gltf, undefined, animations);
        this.name = 'npc';
        this.headLookAt = new HeadLookAt(this);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.headLookAt.update(timeStep); // must run after super (mixer.update is inside)
        this.trackNpcPosition();
    }

    initNpc(node?: PathNode): void {
        this.setBehaviour(new PedestrianBehavior(node));
    }

    initNpcOnNavMesh(navMesh: NavMesh): void {
        this.setBehaviour(new PedestrianBehavior(undefined, navMesh));
    }

    initCop(world: World): void {
        this.setBehaviour(new CopBehaviour(world));
    }

    takeDamage(damage: number): void {
        super.takeDamage(damage);
    }

    onDie(): void {
        super.onDie();
        this.setState(new Die(this));
    }

    public removeFromWorld(world: World): void {
        this.behaviour?.destroy?.();
        super.removeFromWorld(world);
    }

    private trackNpcPosition(): void {
        const y = new THREE.Vector3();
        this.world.npcPos = this.getWorldPosition(y);
    }
}
